import { createContext, useContext } from "react";
import { defaultContent } from "@/lib/content";

const ContentContext = createContext(defaultContent);

export const ContentProvider = ({ children }) => (
  <ContentContext.Provider value={{ content: defaultContent }}>{children}</ContentContext.Provider>
);

export const useContent = () => useContext(ContentContext).content;
